// =========================================
// lookupStore — singleton di lookup condiviso
// =========================================
//
// Contiene lo stato dei dati di lookup (collezioni + cataloghi) alimentato
// dall'AppDataProvider e letto dalle funzioni pure di business logic
// (data/scoring.js, data/assetHelpers.js) e dai lookup di components/index.js.
//
// È stato estratto da AppDataContext.js — che importa React e Firebase —
// proprio per permettere ai moduli di business logic di leggere il lookup
// SENZA tirarsi dietro React/Firebase. Questo rende `scoring.js` e
// `assetHelpers.js` importabili e testabili in Node puro (vedi tests/).

let _lookupData = null;

/** Ritorna lo snapshot corrente del lookup, o null durante l'idratazione. */
export const getLookupData = () => _lookupData;

/** Aggiorna lo snapshot. Chiamato solo dall'AppDataProvider. */
export const setLookupData = (v) => { _lookupData = v; };
